const $ = require("jquery");
require("../../components/ui-components/reviewsCarousel"); // shared reviews block carousel (requires slick itself)
const { initReserveTallestTabPanel } = require("../../components/ui-components/askSimplyPanels");

$(function () {
    initReserveTallestTabPanel();
});
